import React from 'react';
import {formatStyles, calculateAspectRatio} from '../utils';

const IABImage = ({frame_width, frame_height, creative}) => {
  let imageStyles;
  let containerStyles = {};
  const screenFormat = `${frame_width}x${frame_height}`;

  const aspectRatio = calculateAspectRatio(creative.width, creative.height);
  const adFormat = aspectRatio ? aspectRatio : `${creative.width}x${creative.height}`

  const screenFormatConfig = formatStyles[screenFormat]

  if (screenFormatConfig) {
    imageStyles = formatStyles[screenFormat]['iabStyles'][adFormat]
    containerStyles = formatStyles[screenFormat]['containerStyles'][adFormat]
  } 
  if (!imageStyles) {
    imageStyles = {
      width: `${frame_width}px`,
      height: `${frame_height}px`,
      position: 'absolute',
      top: '0px',
      left: '0px',
      objectFit: 'contain',
      backgroundColor: 'black'
    }
  }

  const pixel = {
    opacity: 0
  }

  containerStyles = Object.assign({
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    position: 'absolute'
  }, containerStyles)
  
  return (
    <div style={containerStyles}>
      <div>
        <div style={{textAlign: 'center', paddingBottom: '25px', fontSize: '25px', color: 'rgba(255,255,255,.5)'}}>Adversitement</div>
        <img style={imageStyles} src={creative.url} />
        <img style={pixel} src={creative.burl} />
      </div>
    </div>
  );
}

export default IABImage;